import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

// 路由懒加载
const Jump = (resolve) => {
  import('@/page/Jump').then((module) => {
    resolve(module)
  })
}
const repay = (resolve) => {
  import('@/page/repay').then((module) => {
    resolve(module)
  })
}
const repayStatus = (resolve) => {
  import('@/page/repayStatus').then((module) => {
    resolve(module)
  })
}

const Settle = (resolve) => {
  import('@/page/Settle').then((module) => {
    resolve(module)
  })
}
const repayType = (resolve) => {
  import('@/page/repayType').then((module) => {
    resolve(module)
  })
}
const repayList = (resolve) => {
  import('@/page/repayList').then((module) => {
    resolve(module)
  })
}

const repayRolled = (resolve) => {
  import('@/page/repayRolled').then((module) => {
    resolve(module)
  })
}

export default new Router({
  routes: [
    // 首页
    {
      path: '/',
      name: 'Jump',
      component: Jump,
    },
    //还款
    {
      path: '/repay',
      name: 'repay',
      component: repay,
    },
    {
      path: '/repayStatus',
      name: 'repayStatus',
      component: repayStatus,
    },
    
    //还款方式
    {
      path: '/repayType',
      name: 'repayType',
      component: repayType,
    },
    //还款选择
    {
      path: '/repayList',
      name: 'repayList',
      component: repayList,
    },

    //结清
    {
      path: '/Settle',
      name: 'Settle',
      component: Settle,
    },
    // 展期还款
    {
      path: '/repayRolled',
      name: 'repayRolled',
      component: repayRolled,
    },
  ]

})



// WEBPACK FOOTER //
// ./src/router/index.js